











import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class ValidationErrorsCard extends Vue {
  @Prop({ required: true })
  public errors!: string[]
  @Watch('errors')
  public onPropertyChanged(value: string[], oldvalue: string[]) {}
}
